/* eslint-disable camelcase */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { createBrowserRouter } from 'react-router';
import { RouterProvider } from 'react-router/dom';
import { MsalProvider } from '@azure/msal-react';
import moment from 'moment';
import { CSSBaseline, ThemeProvider } from '@equinor/opt-ui-core';
import ErrorPage from 'AppLayout/ErrorPage';
import store from 'Redux/store';
import { APP_THEME } from 'AppTheme/constants';
import { AuthConfigs } from 'Utils/auth/authConfigs';
import { msalInstance } from 'Utils/auth/authProvider';
import CSSCustomGlobals from 'Widgets/CSSCustomGlobals';
import ErrorBoundary from 'Widgets/ErrorBoundary';
import AppContextProvider from './AppContextProvider';
import AppRootComponent from './AppRootComponent';
moment.updateLocale('en', {
    relativeTime: {
        future: 'in %s',
        past: '%s ago',
        s: 'a second',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    }
});
const container = document.getElementById('app');
const root = createRoot(container);
const basename = AuthConfigs.BASENAME;
const routes = [{ path: '*', element: React.createElement(AppRootComponent, null), errorElement: React.createElement(ErrorPage, null) }];
const opt = {
    basename
};
const router = createBrowserRouter(routes, opt);
const checkLocationPathWithBasename = () => {
    const pathname = window.location.pathname;
    if (pathname === '/') {
        window.location.replace(basename);
        return null;
    }
    if (!pathname.startsWith(basename)) {
        window.location.replace(basename + pathname);
        return null;
    }
};
root.render(React.createElement("div", { className: `app-l-main app-theme-${APP_THEME.mode}` },
    React.createElement(ThemeProvider, { theme: APP_THEME },
        React.createElement(CSSBaseline, null),
        React.createElement(CSSCustomGlobals, null),
        React.createElement(ErrorBoundary, { fallback: React.createElement(ErrorPage, null) },
            React.createElement(Provider, { store: store },
                React.createElement(MsalProvider, { instance: msalInstance },
                    React.createElement(AppContextProvider, null,
                        React.createElement(RouterProvider, { router: router }),
                        basename && checkLocationPathWithBasename())))))));
